/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './implant.reducer';

export const ImplantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const implantEntity = useAppSelector(state => state.implant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="implantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.implant.detail.title">Implant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.implant.id">Id</Translate>
            </span>
          </dt>
          <dd>{implantEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.implant.name">Name</Translate>
            </span>
          </dt>
          <dd>{implantEntity.name}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.implant.active">Active</Translate>
            </span>
          </dt>
          <dd>{implantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="addedBy">
              <Translate contentKey="tinyMedicRestApp.implant.addedBy">Added By</Translate>
            </span>
          </dt>
          <dd>{implantEntity.addedBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.implant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{implantEntity.timestampentry}</dd>
          <dt>
            <span id="dunsNumber">
              <Translate contentKey="tinyMedicRestApp.implant.dunsNumber">Duns Number</Translate>
            </span>
          </dt>
          <dd>{implantEntity.dunsNumber}</dd>
          <dt>
            <span id="brandName">
              <Translate contentKey="tinyMedicRestApp.implant.brandName">Brand Name</Translate>
            </span>
          </dt>
          <dd>{implantEntity.brandName}</dd>
          <dt>
            <span id="deviceDescription">
              <Translate contentKey="tinyMedicRestApp.implant.deviceDescription">Device Description</Translate>
            </span>
          </dt>
          <dd>{implantEntity.deviceDescription}</dd>
          <dt>
            <span id="biodegradable">
              <Translate contentKey="tinyMedicRestApp.implant.biodegradable">Biodegradable</Translate>
            </span>
          </dt>
          <dd>{implantEntity.biodegradable ? 'true' : 'false'}</dd>
          <dt>
            <span id="radioActive">
              <Translate contentKey="tinyMedicRestApp.implant.radioActive">Radio Active</Translate>
            </span>
          </dt>
          <dd>{implantEntity.radioActive ? 'true' : 'false'}</dd>
          <dt>
            <span id="mriSafety">
              <Translate contentKey="tinyMedicRestApp.implant.mriSafety">Mri Safety</Translate>
            </span>
          </dt>
          <dd>{implantEntity.mriSafety}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.implant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{implantEntity.lastupdated}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="tinyMedicRestApp.implant.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{implantEntity.unit}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.implant.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{implantEntity.quantity}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.implant.price">Price</Translate>
            </span>
          </dt>
          <dd>{implantEntity.price}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.implant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{implantEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.implant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{implantEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implant.group">Group</Translate>
          </dt>
          <dd>{implantEntity.group ? implantEntity.group.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implant.manufacturer">Manufacturer</Translate>
          </dt>
          <dd>{implantEntity.manufacturer ? implantEntity.manufacturer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implant.catalog">Catalog</Translate>
          </dt>
          <dd>{implantEntity.catalog ? implantEntity.catalog.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/implant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/implant/${implantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImplantDetail;
